import http from "@/utils/http";


export const EmergencyOpenDoorApi = {
	queryEmergencyOpenDoorPage(queryForm){
		return http.get('/nexus/acsEmergencyOpenDoorOperateLog/page',queryForm);
	}
}